import {InvDetailHistoryMapType, InvDetailHistorySearchParamType, InvDetailType} from "../interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {Dispatch, SetStateAction} from "react";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import {useUser} from "../../../../../util/userContext/UserContext";
import {useModal} from "../../../../../hooks";

interface PropsType {
    presentInvAmount: number
    invDetailHistorySearchParam: InvDetailHistorySearchParamType
    setInvDetailHistorySearchParam: Dispatch<SetStateAction<InvDetailHistorySearchParamType>>
    presentInvDetailHistory: InvDetailHistoryMapType
    invDetail: InvDetailType
}

export default function Tab1({
                                 presentInvAmount,
                                 invDetailHistorySearchParam,
                                 setInvDetailHistorySearchParam,
                                 presentInvDetailHistory,
                                 invDetail
                             }: PropsType) {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser()

    const clickCheck = (name: string) => {
        setInvDetailHistorySearchParam({
            ...invDetailHistorySearchParam,
            pageNo: 1,
            [name]: !invDetailHistorySearchParam[name as keyof InvDetailHistorySearchParamType]
        })
    }

    const btnGoToIncomingCreate = () => {
        goToNavigation("inventory/incoming/create", {invDetail}, false)
    }
    const btnGoToOutgoing = () => {
        goToNavigation("inventory/outgoing/create", {invDetail}, false)
    }
    const btnGoToAdjustment = () => {
        goToNavigation("inventory/adjustment/create", {invDetail}, false)
    }

    const btnGoToIncoming = (inventoryChangeId: number) => {
        goToNavigation(`inventory/inv/history/${inventoryChangeId}`, {}, false)
    }

    return <>
        <div className="content_wrap">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th rowSpan={2} style={{width: "16.66%", verticalAlign: "middle"}}>현재 재고</th>
                    <td><span className="f-20 medium"><DisplayNumber value={presentInvAmount}/></span></td>
                </tr>
                <tr>
                    <td>
                        <div className="d-flex">
                            <AuthorityChecker authorityNames={['inboundWriteYn']}>
                                <button className="btn btn-secondary color2 ms-5px w-100px h-38px rounded ms-0"
                                        onClick={btnGoToIncomingCreate}><img
                                    src={process.env.PUBLIC_URL + "/assets/images/btn_icon1.png"}/>입고
                                </button>
                            </AuthorityChecker>
                            <AuthorityChecker authorityNames={['outboundWriteYn']}>
                                <button className="btn btn-info ms-5px w-100px h-38px rounded"
                                        onClick={btnGoToOutgoing}>
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/btn_icon2.png"}/>출고
                                </button>
                            </AuthorityChecker>
                            <AuthorityChecker authorityNames={['adjustmentWriteYn']}>
                                <button className="btn btn-dark ms-5px w-100px h-38px rounded"
                                        onClick={btnGoToAdjustment}>
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/images/btn_icon3.png"}/>조정
                                </button>
                            </AuthorityChecker>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div className="content_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">재고 내역</h3>
                <div className="filter_toolbar"></div>
            </div>

            <div className="row mb-15px">
                <div className="col-12">
                    <div className="frm_row_grey">
                        <div className="frm_row search justify-content-start w-100">
                            <label htmlFor="" className="form-label frm_label">재고 상태</label>
                            <div className="frm_field">
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input"
                                           type="checkbox"
                                           name="incomingFlag"
                                           id="inlineRadio1"
                                           value="option1"
                                           checked={invDetailHistorySearchParam.incomingFlag}
                                           onClick={() => clickCheck("incomingFlag")}/>
                                    <label className="form-check-label" htmlFor="inlineRadio1">
                                        입고</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input"
                                           type="checkbox"
                                           name="outgoingFlag"
                                           id="inlineRadio2"
                                           value="option2"
                                           checked={invDetailHistorySearchParam.outgoingFlag}
                                           onClick={() => clickCheck("outgoingFlag")}/>
                                    <label className="form-check-label" htmlFor="inlineRadio2">출고</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input"
                                           type="checkbox"
                                           name="adjustmentFlag"
                                           id="inlineRadio3"
                                           value="option3"
                                           checked={invDetailHistorySearchParam.adjustmentFlag}
                                           onClick={() => clickCheck("adjustmentFlag")}/>
                                    <label className="form-check-label" htmlFor="inlineRadio3">조정</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "5%"}}>상태</th>
                    <th>입출고처</th>
                    <th style={{width: "7%"}}>수량</th>
                    <th style={{width: "10%"}}>재고 현황</th>
                    <th>메모</th>
                    <th style={{width: "10%"}}>변경자</th>
                    <th style={{width: "16%"}}>변경일자</th>
                </tr>
                </thead>
                <tbody>
                {presentInvDetailHistory.inventoryDetailHistoryRes.inventoryDetailEachHistoryResList.length !== 0
                    ? presentInvDetailHistory.inventoryDetailHistoryRes.inventoryDetailEachHistoryResList.map(el =>
                        // <AuthorityChecker authorityNames={['inboundReadYn','outboundReadYn','adjustmentReadYn']}>
                        <tr className="clickable" onClick={() => {
                            if (el.changeType === "incoming" && user?.authority.inboundReadYn === "N") {
                                handleModal({
                                    isOpen: true,
                                    contents: "권한이 없습니다. 관리자에게 문의해주십시오.",
                                    type: "alert",
                                    depth: 1
                                })

                                return;
                            }

                            if (el.changeType === "outgoing" && user?.authority.outboundReadYn === "N") {
                                handleModal({
                                    isOpen: true,
                                    contents: "권한이 없습니다. 관리자에게 문의해주십시오.",
                                    type: "alert",
                                    depth: 1
                                })

                                return;
                            }

                            if (el.changeType === "adjustment" && user?.authority.adjustmentReadYn === "N") {
                                handleModal({
                                    isOpen: true,
                                    contents: "권한이 없습니다. 관리자에게 문의해주십시오.",
                                    type: "alert",
                                    depth: 1
                                })

                                return;
                            }
                            
                            btnGoToIncoming(el.inventoryChangeId)
                        }}>
                            {(() => {
                                switch (el.changeType) {
                                    case "incoming":
                                        return <td className="text-center inv_state_incoming">입고</td>
                                    case "outgoing":
                                        return <td className="text-center inv_state_outgoing">출고</td>
                                    case "adjustment":
                                        return <td className="text-center inv_state_adjustment">조정</td>
                                }
                            })()}
                            <td className="text-center">{el.accountName}</td>
                            <td className="text-center">
                                {el.changeAmount > 0
                                    ? <span className="requiredBlue">+{el.changeAmount}</span>
                                    : <span className="required">{el.changeAmount}</span>}
                            </td>
                            <td className="text-center">{el.changeLog}</td>
                            <td>{el.memo}</td>
                            <td className="text-center">{el.fullname}</td>
                            <td className="text-center">{el.modAt}</td>
                        </tr>)
                    : <EmptyTableRow colSpan={7}/>
                }
                </tbody>
            </table>

            <PaginationSub
                totalCount={presentInvDetailHistory.totalCount ?? 0}
                currentPage={invDetailHistorySearchParam.pageNo}
                onChangeCallback={(i: number) => setInvDetailHistorySearchParam({
                    ...invDetailHistorySearchParam,
                    pageNo: i
                })}
            />
        </div>
    </>
}